module.exports = __webpack_public_path__ + "static/features-slide3@2x-1f648ae6ee2099802a4062df6e4a7e38.png";